import { observer } from "mobx-react-lite"
import { createStyles, LoadingOverlay, rem, Box, Title } from "@mantine/core"
import { InstructorStore } from "../../app/store"
import { InstructorEditForm } from "../../features/instructor"
import { useParams } from "react-router-dom"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  title: {
    paddingBottom: theme.spacing.md,
    marginBottom: `calc(${theme.spacing.md} * 1.5)`,
    borderBottom: `${rem(1)} solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]
    }`,

    [theme.fn.smallerThan("sm")]: {
      borderBottom: 0,
    },
  },
}))

// ----------------------------------------------------------------------

export const InstructorEdit = observer(
  function InstructorEdit() {
    const { classes } = useStyles()
    const { instructorId } = useParams<{ instructorId?: string }>()

    return (
      <Box w="100%" pos="relative">
        <LoadingOverlay visible={InstructorStore.isLoading} overlayBlur={2}/>

        <Title order={1} size={24} h={50} className={classes.title}>
          {instructorId
            ? "Редактирование преподавателя"
            : "Добавление преподавателя"}
        </Title>

        <InstructorEditForm/>
      </Box>
    )
  },
)
